<template>
	<div class="data-change">
		<div class="top-line">
			{{dataChange.changer.displayLabel}} 
			<r-simple-time-ago
				:date="dataChange.$internals.metaProperties.meta.dateCreated"
				lowestResolution="s"
				:includeAgo="true"
				:toLowerCase="true"
			></r-simple-time-ago>
		</div>
		<div class="description">
			{{simpleDisplayString}}
		</div>
	</div>
</template>

<script>

import AuditEvents from 'js/data-store/data-store-audit-events';


export default {
	$pubsub:{

	},
	data(){
		return {
			
		}
	},
	props:{
		dataChange:{
			required: true,
			type: Object,
		},
	},
	computed:{
		eventType(){
			return this.dataChange.type;
		},
		simpleDisplayString(){
			if(AuditEvents[this.eventType]){
				return AuditEvents[this.eventType].display.getSimpleDisplayString({
					dataChange: this.dataChange,
				})
			}
			else{
				return this.eventType;
			}
		}
	},
	methods:{
			
	}
}

</script>

<style scoped lang="scss">

.data-change{
	padding: 9px 18px;
	border: 1px solid $p-color-grey-200;
	margin: 6px 0;
	border-radius: 3px;

	.top-line{
		font-weight: 600;
		font-size: 13px;
		line-height: 19px;
		letter-spacing: 0.15px;
		color: $p-color-grey-400;
		margin-bottom: 6px;
	}

	.description{
		color: $p-color-grey-600;
		font-size: 14px;
		font-weight: 500;
		line-height: 20px;		
	}
}


</style>